import InfoIcon from '@mui/icons-material/Info';
import { ClickAwayListener, Grid, IconButton, Popover } from '@mui/material';
import { useState } from 'react';
import { ICandidate } from 'wisestep-api';
import { WsColors } from 'wisestep-base';

import CandidateTooltip from './CandidateTooltip';
interface ICandidateInfoDialog {
  openCandidateInfoDialog?: boolean;
  onClose?: (click: boolean) => void;
  candidateInfo: ICandidate;
  candidateIds: string[];
}
const CandidateInfoDialog = ({
  openCandidateInfoDialog = false,
  candidateInfo,
  candidateIds,
}: ICandidateInfoDialog) => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>();
  const [open, setOpen] = useState(openCandidateInfoDialog);
  const handleClose = () => {
    setOpen(false);
  };

  const viewCandidateInfo = () => {
    setOpen(true);
  };

  const handlePopoverOpen = (event) => {
    setAnchorEl(event?.currentTarget);
  };
  return (
    <Grid item>
      <ClickAwayListener onClickAway={handleClose}>
        <div>
          <IconButton
            onClick={(event) => {
              viewCandidateInfo();
              handlePopoverOpen(event);
            }}
            sx={{ color: WsColors.TheBlues400 }}
            aria-describedby={open ? 'simple-popover' : undefined}
          >
            <InfoIcon />
          </IconButton>
          <Popover
            id={open ? 'simple-popover' : undefined}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            PaperProps={{
              style: {
                width: '900px',
                borderRadius: '10px',
              },
            }}
          >
            <CandidateTooltip candidate={candidateInfo} onClose={handleClose} ids={candidateIds} />
          </Popover>
        </div>
      </ClickAwayListener>
    </Grid>
  );
};

export default CandidateInfoDialog;
